import React from 'react';
import Paragraph from 'src/elements/typography/paragraph';
import { palette } from 'src/styles/colors';
import { FooterLink, FooterLinkGroupProps } from '../../Footer/Links/Footer.links';
import { LinkList, FooterLinksContainer, LinksColumn, FooterLinksMobileContainer } from './FooterLinks.styles';

const FEATURES_AND_PRICING: FooterLinkGroupProps = {
  title: 'FEATURES & PRICING',
  links: [
    { text: 'Pricing', url: '/pricing' },
    { text: 'Features Overview', url: '/features' },
    { text: 'Online Courses', url: '/features/online-courses' },
    { text: 'Embeds', url: '/features/embeds' },
    { text: 'Automations', url: '/features/automations' },
    { text: 'Move to Mighty', url: '/migration' },
  ],
};

const COMPANY: FooterLinkGroupProps = {
  title: 'COMPANY',
  links: [
    { text: 'About Us', url: '/about' },
    { text: 'Careers', url: '/careers' },
  ],
};

const MIGHTY_PRO: FooterLinkGroupProps = {
  title: 'MIGHTY PRO',
  links: [{ text: 'About Mighty Pro', url: '/pro' }],
};

const EDUCATION_AND_TOOLS: FooterLinkGroupProps = {
  title: 'EDUCATION & TOOLS',
  links: [
    { text: 'Case Studies', url: '/case-studies' },
    { text: 'Encyclopedia', url: '/encyclopedia' },
    { text: 'Resource Center', url: '/resources' },
    { text: 'Creator Calculator', url: 'https://creatorscalculator.com', external: true },
    { text: 'New Creator Manifesto', url: 'https://newcreatormanifesto.com', external: true },
  ],
};

const COMMUNITY_AND_SUPPORT: FooterLinkGroupProps = {
  title: 'COMMUNITY & SUPPORT',
  links: [
    {
      text: 'Mighty Community',
      url: 'https://community.mightynetworks.com/?utm_source=website&utm_medium=footer&utm_campaign=mc_education',
      external: true,
    },
    { text: 'Help', url: 'https://faq.mightynetworks.com', external: true },
    { text: 'Mighty Spotlight', url: '/find/spotlight' },
  ],
};

const FooterLinks = (): JSX.Element => {
  const renderLinkList = ({ title, links }: FooterLinkGroupProps) => (
    <LinkList>
      <Paragraph
        text={title}
        color={palette.white}
        align='left'
        standardSize='0.875'
        weight={700}
      />
      {links.map((link) => (
        <FooterLink
          key={link.text}
          link={link}
        />
      ))}
    </LinkList>
  );

  return (
    <>
      <FooterLinksContainer className='footer-links-container'>
        <LinksColumn>{renderLinkList(FEATURES_AND_PRICING)}</LinksColumn>
        <LinksColumn>
          {renderLinkList(MIGHTY_PRO)}
          {renderLinkList(COMPANY)}
        </LinksColumn>
        <LinksColumn>{renderLinkList(EDUCATION_AND_TOOLS)}</LinksColumn>
        <LinksColumn>{renderLinkList(COMMUNITY_AND_SUPPORT)}</LinksColumn>
      </FooterLinksContainer>
      <FooterLinksMobileContainer className='footer-links-mobile-container'>
        <LinksColumn>
          {renderLinkList(FEATURES_AND_PRICING)}
          {renderLinkList(MIGHTY_PRO)}
          {renderLinkList(COMPANY)}
        </LinksColumn>
        <LinksColumn>
          {renderLinkList(EDUCATION_AND_TOOLS)}
          {renderLinkList(COMMUNITY_AND_SUPPORT)}
        </LinksColumn>
      </FooterLinksMobileContainer>
    </>
  );
};

export default FooterLinks;
